module.exports = __webpack_public_path__ + "img/bg.31724317.jpeg";